<template>
    <div class="signature mt-6">
        <div class="p-5 is-size-5">
            <p><i class="far fa-file-signature mr-3"></i>{{component.content.attributes.signature_clause}}</p>
        </div>

        <div class="signature-pad">
            <div class="sig-line"></div>
            <div class="sig-x">
                <b-icon icon="times"/>
            </div>
            <div class="sig-name">{{ user.first_name }} {{ user.last_name }}</div>
            <div class="sig-buttons">
                <b-button size="is-small" @click="undo" class="mr-2">
                    <b-icon icon="undo" class="mr-1"/>
                    Undo
                </b-button>
                <b-button size="is-small" @click="clear">
                    <b-icon icon="eraser" class="mr-1"/>
                    Clear
                </b-button>
            </div>
            <vueSignature class="sig" ref="logsignature" :sigOption="option" :w="'1000px'" :h="'180px'"/>
        </div>
    </div>
</template>

<script>
    import VueSignature from 'vue-signature';

    export default {
        props: ['user', 'component'],
        components: {VueSignature},
        data() {
            let _this = this;
            return {
                option: {
                    penColor: 'rgb(0, 0, 0)',
                    backgroundColor: 'rgb(255, 255, 255)',
                    // minWidth: 0.5,
                    // maxWidth: 2.5,
                    // throttle: 16,
                    // velocityFilterWeight: 0.7,
                    onEnd: function () {
                        _this.save();
                    }
                },
            }
        },
        methods: {
            clear() {
                this.$refs.logsignature.clear();
                this.$emit('input', null);
            },
            undo() {
                this.$refs.logsignature.undo();
                this.save();
            },
            save() {
                this.$emit('input', this.$refs.logsignature.save());
            }
        }
    };
</script>

<style lang="scss" scoped>
    .signature {
        font-size: 0.9rem;
        background: white;

    .signature-pad {
        position: relative;

    .sig {

    }

    .sig-x {
        position: absolute;
        bottom: 45px;
        left: 20px;
        font-size: 1.5rem;
    }

    .sig-name {
        position: absolute;
        bottom: 20px;
        left: 50px;
        font-size: 1rem;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

    }

    .sig-line {
        position: absolute;
        bottom: 45px;
        left: 20px;
        right: 20px;
        border-bottom: 2px solid red;
    }

    .sig-buttons {
        position: absolute;
        top: 10px;
        right: 20px;
    }
    }
    }
</style>
